import React from "react";
import { ListResponse } from "src/types";

import { fetchAllEvents, FetchAllEventsPayload } from "@admin/api/event";
import { showErrorToast } from "@shared/toasts/Toasts";

import { EventReport } from "../../dashboard/devices/types";

export const useGetAllEvents = (payload: FetchAllEventsPayload = {}) => {
    const [isLoading, setIsLoading] = React.useState(true);
    const [data, setData] = React.useState<ListResponse<EventReport>>({
        list: [],
        count: 0,
        message: "",
    });

    React.useLayoutEffect(() => {
        setIsLoading(true);

        void fetchAllEvents(payload)
            .then((response) => setData(response))
            .catch((error) => {
                const err = error as Error;
                showErrorToast(err.message);
            })
            .finally(() => setIsLoading(false));
    }, [
        payload.pageIndex,
        payload.pageSize,
        payload.level,
        payload.workspaceId,
        payload.groupIds,
        payload.entityId,
        payload.category,
        payload.createdFrom,
        payload.createdTo,
        payload.searchTerm,
    ]);

    return { data, isLoading };
};
